import type React from 'react';
import { useTranslation } from 'react-i18next';
import AbsenceInput from '@/features/Quote/components/settings/absence/Input';
import {
	type AbsenceInfo,
	toAbsenceValues
} from '@/features/Quote/components/settings/absence/values';
import type { AppData } from '@/types/app';
import SectionCard from './SectionCard';

interface AbsenceSectionProps {
	appData: AppData;
}

/**
 * "Verzuim" — reuses the flow's own absence inputs, disabled. That keeps the
 * years in the flow's order (most recent first) and the formatting identical.
 */
const AbsenceSection = ({ appData }: AbsenceSectionProps): React.JSX.Element => {
	const { t } = useTranslation();
	const absenceInfo = (appData.premium_variables?.absence_info ?? null) as AbsenceInfo;
	const absenceValues = toAbsenceValues(absenceInfo);
	const hasAnyRate = Object.values(absenceValues).some((value) => value !== '');

	return (
		<SectionCard
			title={t('requestOverview.premiumVars.absenceHeading')}
			testId="dossier-section-absence"
		>
			{hasAnyRate ? (
				<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
					<p className="max-w-xs text-sm text-muted-foreground">
						{t('quotes.settings.absence.detailDescription')}
					</p>
					<div className="flex gap-2 max-w-[400px]">
						{['1', '2', '3'].map((index) => (
							<AbsenceInput
								key={`vz${index}Input`}
								index={index}
								absenceValues={absenceValues}
								disabled
							/>
						))}
					</div>
				</div>
			) : (
				<p className="text-sm italic text-muted-foreground/70">
					{t('requestOverview.premiumVars.noAbsence')}
				</p>
			)}
		</SectionCard>
	);
};

export default AbsenceSection;
